import { render, staticRenderFns } from "./Graphs.vue?vue&type=template&id=b8e2f966"
import script from "./Graphs.vue?vue&type=script&lang=js"
export * from "./Graphs.vue?vue&type=script&lang=js"
import style0 from "./Graphs.vue?vue&type=style&index=0&id=b8e2f966&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports